// extracted by mini-css-extract-plugin
export default {"btn":"GreyButton_btn__lO1U5"};